import '../../assets/styles/css/index.css'
import './GramaticaVV.css'
import { useTranslation } from 'react-i18next'
import NavBarTop from '../../components/NavBarTop'
import Footer from '../../components/Footer'

const GramaticaVV = () => {
  const { t } = useTranslation()

  return (
    <div className={'wrapper'}>
      <div className={'navBar'}>
        <NavBarTop />
      </div>
      <div className={`${'container'} container`}>
        <div className={'wrapperContent'}>
          <h2 className={'title'}>{t('AVISO LEGAL - GRAMÁTICA VV')}</h2>
          <p>
            {t(
              'El canal de Telegram denominado “GRAMÁTICA VV” está gestionado y administrado por la Sra. Elena Escribano y el Sr. Félix Esteso, colaboradores de EDITORIAL VICENS VIVES, S.A.U. (en adelante VICENS VIVES) y, adicionalmente, por personal de VICENS VIVES.'
            )}
          </p>
          <p>
            {t(
              'VICENS VIVES no realizará ningún tipo de tratamiento, captación, difusión y almacenamiento de los datos de carácter personal que puedan aparecer y/o compartirse en la plataforma Telegram y/o en su canal “GRAMÁTICA VV”.'
            )}
          </p>
          <p>
            {t(
              'Los datos personales que puedan aparecer en el canal “GRAMÁTICA VV” son los que los usuarios han facilitado directamente a la plataforma Telegram para poder acceder a sus servicios. VICENS VIVES no hará ningún uso de ellos para fines comerciales u otra finalidad no autorizada previamente por los usuarios.'
            )}
          </p>
          <p>
            {t(
              'Todos los derechos de propiedad intelectual del contenido del canal “GRAMÁTICA VV” y su diseño gráfico, son propiedad exclusiva de VICENS VIVES, y es a quien le corresponde el ejercicio exclusivo de los derechos de explotación de los mismos. Así, queda prohibida su reproducción, distribución, comunicación pública y modificación, total o parcial, sin previa autorización expresa de VICENS VIVES. De igual forma, todos los signos distintivos, marcas, nombres comerciales o signos de cualquier clase, propiedad de VICENS VIVES, contenidos del canal “GRAMÁTICA VV” están protegidos por ley.'
            )}
          </p>
          <p>
            {t(
              'VICENS VIVES no se responsabiliza del mal uso que se realice de los contenidos del canal “GRAMÁTICA VV”, siendo responsabilidad exclusiva de la persona que accede a ellos o los utiliza. Tampoco asume responsabilidad alguna por la información contenida en las páginas web de terceros a las que se pueda acceder a través de enlaces desde el canal. La presencia de estos enlaces tiene una finalidad informativa, y no constituyen en ningún caso una invitación a la contratación de productos o servicios que se puedan ofrecer en la página web de destino. En el caso que los administradores del canal tuvieran conocimiento efectivo de que la actividad o la información a la que remiten estos enlaces es ilícita, constitutiva de delito o que puede lesionar bienes o derechos de terceros susceptibles de indemnización, actuará con la diligencia necesaria para suprimir o inutilizar el enlace correspondiente a la mayor brevedad posible.'
            )}
          </p>
          <p>
            {t(
              'VICENS VIVES declina toda responsabilidad derivada del intercambio de información entre usuarios a través del canal “GRAMÁTICA VV”.'
            )}
          </p>
          <p>
            {t(
              'Los usuarios se obligan a utilizar el canal “GRAMÁTICA VV” de conformidad con la ley. El usuario se obliga a no utilizar el canal con fines o efectos ilícitos o contrarios al contenido del presente aviso legal, lesivos de los intereses o derechos de terceros, o que de cualquier forma pueda dañar, inutilizar o deteriorar el buen funcionamiento del canal, o impedir un normal disfrute del canal por otros usuarios. Asimismo, el usuario se obliga expresamente a no alterar o distribuir con fines lucrativos la información y los datos de carácter personal que se encuentren en el canal “GRAMÁTICA VV”.'
            )}
          </p>
          <p>
            {t(
              'VICENS VIVES y los administradores del canal harán todo lo razonablemente posible para vigilar la legalidad de los contenidos, imágenes, opiniones y demás información que se transmita a través del canal. Sin embargo, al no ser posible el control absoluto de estos, el usuario será el único responsable de la información, imágenes, opiniones, alusiones o contenidos de cualquier tipo que comunique, aloje, transmita, ponga a disposición o exhiba a través del canal.'
            )}
          </p>
          <p>
            {t(
              'En especial, VICENS VIVES no podrá ser considerado responsable editorial y declara expresamente que no se identifica con ninguna de las opiniones que los usuarios del canal “GRAMÁTICA VV” puedan emitir a través del canal, de cuyas consecuencias se hace enteramente responsable el emisor de las mismas.'
            )}
          </p>
          <p>
            {t(
              'VICENS VIVES o los administradores del canal podrán limitar el acceso al canal de opiniones, informaciones, comentarios, imágenes o dibujos que los usuarios del canal hagan llegar. Lo anterior no supone, en modo alguno, la obligación de los administradores del canal de controlar los contenidos que puedan difundirse a través del canal de Telegram, sino la voluntad de evitar, en la medida de lo posible, que a través del canal “GRAMÁTICA VV” puedan difundirse contenidos u opiniones que puedan ser considerados difamatorios, racistas, sexistas, xenófobos, discriminatorios, pornográficos, violentos o que, de algún modo, vayan en contra de la moral, el orden público y las buenas costumbres, o resulten claramente ilícitos o ilegales.'
            )}
          </p>
          <p>
            {t(
              'En caso de que un usuario del canal “GRAMÁTICA VV” considere que otro usuario ha vulnerado sus derechos a través del canal, recomendamos que se ponga en contacto con los administradores del canal “GRAMÁTICA VV” para que se tomen las medidas oportunas. Asimismo, pedimos a los usuarios que se pongan en contacto con los administradores del canal para denunciar cualquier mal uso del mismo o una vulneración de derechos por parte de otro usuario del canal de Telegram.'
            )}
          </p>
        </div>
      </div>
      <Footer showCatLang={false} />
    </div>
  )
}

export default GramaticaVV
